import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { PrivateProfile } from '../models/private-profile';
import { Product } from '../models/product';
import { AlertService } from './alert.service';
import { convertSnaps } from './db-utils';
import { FirebaseAuthService } from './firebase-auth.service';
import { Departamento } from '../models/departamento';
import { Municipio } from '../models/municipio';
import { DocType } from '../models/doc-type';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  listProductsSession: Product[] = [];
  // totalShoppingCartValueToPayObs: Observable<number> = new BehaviorSubject<number>(0);
  totalShoppingCartValueToPay = 0;
  totalShoppingCartRevenuePoints = 0;
  totalShoppinCartValueToPayInPoints = 0;


  constructor(private http: HttpClient, private fireStore: AngularFirestore, private firebaseAuthService: FirebaseAuthService,
              private alertService: AlertService) {

  }


  getDepartamentos(): Observable<Departamento[]> {

    return this.fireStore.collection('departamentos')
      .snapshotChanges()
      .pipe(map(snaps => convertSnaps<Departamento>(snaps))
        , first()); // Con first Se asegura que el observable es completado entonces solo trae los datos una vez

  }

  getMunicipiosPorDepartamento(departamentoName: string): Observable<Municipio[]> {
    return this.fireStore.collection('municipios',
      ref => ref.where('departamento', '==', departamentoName))
      .snapshotChanges()
      .pipe(
        map(snaps => {
          const municipios = convertSnaps<Municipio>(snaps);
          return municipios;
        }), first()
      );
  }

  getDocumentTypes(): Observable<DocType[]> {
    return this.fireStore.collection('documentTypes').snapshotChanges()
      .pipe(map(snaps => convertSnaps<DocType>(snaps))
        , first());
  }

  getCities(): Observable<any[]> {
    return this.http.get<any[]>('https://www.datos.gov.co/resource/xdk5-pm3f.json');
  }


  addProductToShoppingCartInLocalStorage(product: Product): void {
    const tugessiShoppingCart = JSON.parse(localStorage.getItem('tugessiShoppingCart'));

    if (tugessiShoppingCart) {

      const newTugessiShoppingCart: Product[] = tugessiShoppingCart;

      if (newTugessiShoppingCart.some(productInCart => productInCart.id === product.id)){

        const productIndex = newTugessiShoppingCart.findIndex(productInCart => productInCart.id === product.id);
        newTugessiShoppingCart[productIndex].quantity = newTugessiShoppingCart[productIndex].quantity + product.quantity;
      } else {
        product.suggestedProducts = [];
        // product.quantity = 1;

        newTugessiShoppingCart.push(product);

      }
      localStorage.setItem('tugessiShoppingCart', JSON.stringify(newTugessiShoppingCart));

    } else {
      const newTugessiShoppingCart: Product[] = [];

      product.suggestedProducts = [];
      newTugessiShoppingCart.push(product);

      localStorage.setItem('tugessiShoppingCart', JSON.stringify(newTugessiShoppingCart))
    }
  }

  async addProductToShoppingCart(product: Product): Promise<void>{

    const answ = await this.firebaseAuthService.getPrivateProfileUserById(this.firebaseAuthService.publicUser.uid).toPromise();
    this.firebaseAuthService.privateProfile = answ[0];

    const shoppingCart: Product[] = this.firebaseAuthService.privateProfile.shoppingCart;

    if ( shoppingCart.some(productInCart => productInCart.id === product.id)) {

      const productIndex = shoppingCart.findIndex(productInCart => productInCart.id === product.id);
      shoppingCart[productIndex].quantity = shoppingCart[productIndex].quantity + product.quantity;
      this.firebaseAuthService.privateProfile.shoppingCart = shoppingCart;
    } else {
      // product.quantity = 1;
      this.firebaseAuthService.privateProfile.shoppingCart.push(product);
    }


    return this.fireStore.doc(`users/${this.firebaseAuthService.publicUser.uid}/privateProfile/${this.firebaseAuthService.privateProfile.id}`)
            .update({
              shoppingCart : this.firebaseAuthService.privateProfile.shoppingCart
            });

  }


  async removeProductFromShoppingCart(productId: string): Promise<void>{

    const answ = await this.firebaseAuthService.getPrivateProfileUserById(this.firebaseAuthService.publicUser.uid).toPromise();
    this.firebaseAuthService.privateProfile = answ[0];

    const shoppingCart: Product[] = this.firebaseAuthService.privateProfile.shoppingCart;

    if ( shoppingCart.some(productInCart => productInCart.id === productId)) {

      const productIndex = shoppingCart.findIndex(productInCart => productInCart.id === productId);
      shoppingCart.splice(productIndex, 1);

      this.firebaseAuthService.privateProfile.shoppingCart = shoppingCart;

      return this.fireStore.doc(`users/${this.firebaseAuthService.publicUser.uid}/privateProfile/${this.firebaseAuthService.privateProfile.id}`)
        .update({
          shoppingCart : this.firebaseAuthService.privateProfile.shoppingCart
        });
    } else {

      return;
    }
  }

  async clearShoppingCart(): Promise<void> {

    this.firebaseAuthService.privateProfile.shoppingCart = [];

    return this.fireStore.doc(`users/${this.firebaseAuthService.publicUser.uid}/privateProfile/${this.firebaseAuthService.privateProfile.id}`)
      .update({
        shoppingCart: this.firebaseAuthService.privateProfile.shoppingCart
      });
  }


  removeProductFromShoppingCartInLocalStorage(productId: string): void {

    const tugessiShoppingCart = JSON.parse(localStorage.getItem('tugessiShoppingCart'));

    if (tugessiShoppingCart) {

      const newTugessiShoppingCart: Product[] = tugessiShoppingCart;

      if (newTugessiShoppingCart.some(productInCart => productInCart.id === productId)){

        const productIndex = newTugessiShoppingCart.findIndex(productInCart => productInCart.id === productId);
        newTugessiShoppingCart.splice(productIndex, 1);
        localStorage.setItem('tugessiShoppingCart', JSON.stringify(newTugessiShoppingCart));
      }
    }
  }


  async updateProductQuantityOfShoppinCart(product: Product): Promise<void>{
    const answ = await this.firebaseAuthService.getPrivateProfileUserById(this.firebaseAuthService.publicUser.uid).toPromise();
    this.firebaseAuthService.privateProfile = answ[0];

    const shoppingCart: Product[] = this.firebaseAuthService.privateProfile.shoppingCart;

    if ( shoppingCart.some(productInCart => productInCart.id === product.id)) {

      const productIndex = shoppingCart.findIndex(productInCart => productInCart.id === product.id);
      shoppingCart[productIndex].quantity = product.quantity;

      this.firebaseAuthService.privateProfile.shoppingCart = shoppingCart;

      return this.fireStore.doc(`users/${this.firebaseAuthService.publicUser.uid}/privateProfile/${this.firebaseAuthService.privateProfile.id}`)
      .update({
        shoppingCart : this.firebaseAuthService.privateProfile.shoppingCart
      });

    } else {
      return;
    }
  }


  updateProductQuantityOfShoppinCartInLocalStorage(product: Product): void {

    const tugessiShoppingCart = JSON.parse(localStorage.getItem('tugessiShoppingCart'));

    if (tugessiShoppingCart) {
      const newTugessiShoppingCart: Product[] = tugessiShoppingCart;

      if (newTugessiShoppingCart.some(productInCart => productInCart.id === product.id)){

        const productIndex = newTugessiShoppingCart.findIndex(productInCart => productInCart.id === product.id);
        newTugessiShoppingCart[productIndex].quantity = product.quantity;

        localStorage.setItem('tugessiShoppingCart', JSON.stringify(newTugessiShoppingCart));
      }
    }
  }


  resolveShoppingCart(): Product[] {
    if (this.firebaseAuthService.privateProfile) {
      this.calculateTotals();
      return this.firebaseAuthService.privateProfile.shoppingCart;
  } else {
      const tugessiShoppingCart: Product[] = JSON.parse(localStorage.getItem('tugessiShoppingCart'));

      if ( tugessiShoppingCart) {
          return tugessiShoppingCart;
      } else {
          return [];
      }
   }
  }


  async checkShopingCartInLocalStorage(): Promise<void> {
    const shoppingCartInLocalStorage: Product[] = JSON.parse(localStorage.getItem('tugessiShoppingCart'));

    if (shoppingCartInLocalStorage) {


      const shoppingCart: Product[] = this.firebaseAuthService.privateProfile.shoppingCart;

      if (shoppingCart.length > 0) {
        shoppingCartInLocalStorage.forEach(productInLocalStorage => {
          if ( shoppingCart.some(productInCart => productInCart.id === productInLocalStorage.id)) {
            const productIndex = shoppingCart.findIndex(productInCart => productInCart.id === productInLocalStorage.id);
            shoppingCart[productIndex].quantity = shoppingCart[productIndex].quantity + productInLocalStorage.quantity;
          } else {
            shoppingCart.push(productInLocalStorage);
          }
        });

        await this.firebaseAuthService.updatePrivateProfileUser(this.firebaseAuthService.publicUser.uid, {
          id: this.firebaseAuthService.privateProfile.id,
          shoppingCart
        }).toPromise();

        this.listProductsSession = this.firebaseAuthService.privateProfile.shoppingCart;

        localStorage.removeItem('tugessiShoppingCart');

        this.alertService.openAlertDialog('Tu carrito de compras se ha sincronizado, por favor verifica antes de realizar la compra',
             false, false);



        return ;

      } else {

        await this.firebaseAuthService.updatePrivateProfileUser(this.firebaseAuthService.publicUser.uid, {
          id: this.firebaseAuthService.privateProfile.id,
          shoppingCart: shoppingCartInLocalStorage
        }).toPromise();

        this.listProductsSession = this.firebaseAuthService.privateProfile.shoppingCart;
        this.calculateTotals();
        localStorage.removeItem('tugessiShoppingCart');
        return;
      }

    } else {
      console.log('no hay productos en el localstorage');
      if ( this.firebaseAuthService.privateProfile.shoppingCart.length > 0) {

        this.listProductsSession = this.firebaseAuthService.privateProfile.shoppingCart;
        this.calculateTotals();
      }
      return;
    }
  }

  calculateTotals(): void {

    let sum = 0;
    let sumPoints = 0;
    let sumPointsCost = 0;

    this.listProductsSession.forEach(product => {
      sum += product.price * product.quantity;
      sumPoints += product.pointsRevenue * product.quantity;
      sumPointsCost += product.points * product.quantity;
    });

    // this.totalShoppingCartValueToPayObs = new BehaviorSubject<number>(sum);
    this.totalShoppingCartValueToPay = sum;
    this.totalShoppingCartRevenuePoints = sumPoints;
    this.totalShoppinCartValueToPayInPoints = sumPointsCost;

    console.log('totales calculados');

  }

}
